module.exports = {
  title: 'Pagination',
  context: {
    totalPages: '4',
    currentPage: {
      page: '2',
      url: 'page/2'
    },
    nextPage: {
      page: '3',
      url: 'page/3'
    },
    prevPage: {
      page: '1',
      url: 'page/1'
    },
    getPrevUrls: [
      {
        page: '1',
        url: ''
      }
    ],
    getNextUrls: [
      {
        page: '3',
        url: 'page/3'
      },
      {
        page: '4',
        url: 'page/4'
      }
    ]
  }
}
